module.exports = __webpack_public_path__ + "static/media/tom_image.760a2e84.png";